import React, { ReactNode } from 'react'

interface SubscriptionDetailProps {
  title: string | ReactNode
  description: string
}

const SubscriptionDetail: React.FC<SubscriptionDetailProps> = ({ title, description }) => {
  return (
    <div className="mt-4">
      <p className="color-gray-7">{title}</p>
      <p>{description}</p>
    </div>
  )
}

export default SubscriptionDetail
